<div class="pagination-container">
  <div class="">
    <button *ngIf="hideResync" [attr.dpad]="DpadZoneType.SCREEN"  [style.--scale-dpad]="1.3"  x-dpad="0" [attr.y-dpad]="dpadY"  class="reload-btn" (click)="syncData()">
      <i class="pi pi-sync"></i>
    </button>
  </div>
  <div *ngIf="!hidePaging" class="pagination-wrapper " #paginationWrapper>
    <div class="pagination">
      <div *ngFor="let page of pageNumbers; let i=index" class="w-100 h-100">
        <button *ngIf="page !== null" [class.active]="page === currentPage" (click)="selectPage(page)"
          [style.--scale-dpad]="dpadScale" [attr.dpad]="DpadZoneType.SCREEN" [attr.x-dpad]="hideResync ? (i % 6) + 1 : i" [attr.y-dpad]="dpadY">
          {{ page}}</button>
        <button *ngIf="page === null" [disabled]="true"></button>
      </div>
    </div>
  </div>
  <div class="">
    <button *ngIf="hideLock" [attr.dpad]="DpadZoneType.SCREEN" [style.--scale-dpad]="1.3"  [attr.x-dpad]="dpadXLockBtn" [attr.y-dpad]="dpadY" [ngClass]="isLocked ? 'lock-btn' : 'unlock-btn'" (click)="toggleLock()">
      <div [ngClass]="isLocked ? 'lock' : 'unlock'"></div>
    </button>
  </div>
  <div class="">
    <button *ngIf="!hideSetting" (click)="clickSetting()" class="setting-btn mr-5">
      <i class="pi pi-cog"></i>
    </button>
  </div>
</div>